import { createSlice } from '@reduxjs/toolkit';
import { getKeysNKeyMap } from 'utils';
import { createAsyncAction } from '../action';
import { message } from '@docon/docon-ui-library';
import { Status } from '.';

const getAllQsrCheckups = createAsyncAction('getAllQsrCheckups', 'getAllQsrCheckups');
const downloadCheckupStatusExcel = createAsyncAction('downloadCheckupStatusExcel', 'downloadCheckupStatusExcel');
const updateCheckupStatus = createAsyncAction('updateCheckupStatus', 'updateCheckupStatus');
const resendCheckupSMS = createAsyncAction('resendCheckupSMS', 'resendCheckupSMS');
const getFilteredCheckupStatus = createAsyncAction('getFilteredCheckupStatus', 'getFilteredCheckupStatus');

interface IInitialState {
  isFetchingCheckups: boolean;
  isFetchingFilteredCheckups: boolean;
  isUpdatingCheckupStatus: boolean;
  checkupStatusExcelDownloadLink: string;
  checkupStatusExcelDownloadStatus: string;
  fetchingCheckupsError: string;
  updatingCheckupStatus: string;
  checkups: any;
  checkupsPerPage: number;
  totalCheckups: number;
  totalPages: number;
}

const initialState: IInitialState = {
  isFetchingCheckups: false,
  isFetchingFilteredCheckups: false,
  isUpdatingCheckupStatus: false,
  checkupStatusExcelDownloadLink: '',
  checkupStatusExcelDownloadStatus: '',
  fetchingCheckupsError: '',
  updatingCheckupStatus: '',
  checkups: [],
  checkupsPerPage: 20,
  totalCheckups: 0,
  totalPages: 1,
};

export const counterSlice = createSlice({
  name: 'checkup',
  initialState,
  reducers: {
    updateCheckupState: (state, action) => Object.assign(state, action.payload),
  },
  extraReducers: {
    [getAllQsrCheckups.pending as any]: (state) => {
      state.isFetchingCheckups = true;
    },
    [getAllQsrCheckups.fulfilled as any]: (state, { payload }) => {
      const { data = [], total, total_pages, page_number } = payload?.data || {};
      state.isFetchingCheckups = false;
      state.checkups = getKeysNKeyMap(data || [], 'id')?.data;
      state.totalCheckups = total;
      state.checkupsPerPage = page_number === 1 ? state.checkups?.length : state.checkupsPerPage;
      state.totalPages = total_pages;
    },
    [getAllQsrCheckups.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.isFetchingCheckups = false;
      }
    },

    [downloadCheckupStatusExcel.pending as any]: (state) => {
      state.checkupStatusExcelDownloadLink = '';
      state.checkupStatusExcelDownloadStatus = Status.pending;
    },
    [downloadCheckupStatusExcel.fulfilled as any]: (state, { payload }) => {
      state.checkupStatusExcelDownloadLink = window.URL.createObjectURL(new Blob([payload], { type: 'application/csv' }));
      state.checkupStatusExcelDownloadStatus = Status.fulfilled;
    },
    [downloadCheckupStatusExcel.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.checkupStatusExcelDownloadLink = '';
        state.checkupStatusExcelDownloadStatus = Status.rejected;
      }
    },

    [updateCheckupStatus.pending as any]: (state) => {
      state.isUpdatingCheckupStatus = true;
      state.updatingCheckupStatus = Status.pending;
    },
    [updateCheckupStatus.fulfilled as any]: (state) => {
      state.isUpdatingCheckupStatus = false;
      state.updatingCheckupStatus = Status.fulfilled;
    },
    [updateCheckupStatus.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.isUpdatingCheckupStatus = false;
        state.updatingCheckupStatus = Status.rejected;
      }
    },

    [resendCheckupSMS.fulfilled as any]: () => {
      message.success('Successfully sms resent');
    },

    [getFilteredCheckupStatus.pending as any]: (state) => {
      state.isFetchingFilteredCheckups = true;
    },
    [getFilteredCheckupStatus.fulfilled as any]: (state, { payload }) => {
      const { data = [], total, total_pages, page_number } = payload?.data || {};
      state.isFetchingFilteredCheckups = false;
      state.checkups = getKeysNKeyMap(data || [], 'id')?.data;
      state.totalCheckups = total || state.checkups?.length;
      state.checkupsPerPage = page_number === 1 ? state.checkups?.length : state.checkupsPerPage;
      state.totalPages = total_pages || 1;
    },
    [getFilteredCheckupStatus.rejected as any]: (state, { error }) => {
      if (error.name !== 'AbortError') {
        state.isFetchingFilteredCheckups = false;
      }
    },
  },
});

const { updateCheckupState } = counterSlice.actions;
export {
  updateCheckupState,
  getAllQsrCheckups,
  downloadCheckupStatusExcel,
  updateCheckupStatus,
  resendCheckupSMS,
  getFilteredCheckupStatus,
};
export default counterSlice.reducer;
